export default "__VITE_ASSET__DJEpQtHi__"